import React from "react";
import { Link } from "react-router-dom";
import ListKarya from "./ListKarya";

function Karya() {
  return (
    <div className="text-xl" data-aos="zoom-up">
      <h1 className="text-2xl md:text-3xl font font-semibold mb-2 dark:text-gray-200">
        Project/Karya
      </h1>
      <p className="text-lg md:text-xl font-normal mt-10 underline decoration-4 decoration-pink-500 dark:text-gray-200">
        Hasil belajar mubin, sederhana tapi bikin sendiri,
      </p>
      <p className="text-lg md:text-xl font-normal mt-10 dark:text-gray-200">
        <b>Catatan :</b> Saya terbuka untuk bekerja jika ada project menarik,
        spesialis bagian front end, termasuk landing page, company profile,
        personal profile, ecommerce, blog, siakad dll. beritahu saya{" "}
        <Link to="/kontak">
          <span className="underline underline-offset-4 decoration-4 decoration-sky-500">
            disini
          </span>
        </Link>
      </p>
      <h1 className="text-xl md:text-2xl font font-semibold mt-5 mb-2 dark:text-gray-200">
        <span className="font-black">|</span> Hasil Belajar [WEB]
      </h1>
      <ListKarya />
    </div>
  );
}

export default Karya;
